import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoEmspUserListLastConnectionCell } from './emsp-bo-emsp-user-list-last-connection.cell';
import { EmspBoEmspUserListLastConnectionHeader } from './emsp-bo-emsp-user-list-last-connection.header';

export const EmspBoEmspUserListLastConnectionColumn: IdentifiedColumnDef<
  EmspUserModel,
  EmspUserModel['lastConnection']
> = {
  enableSorting: true,
  header: EmspBoEmspUserListLastConnectionHeader,
  cell: EmspBoEmspUserListLastConnectionCell,
};
